module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70017/img/content-remix-post-publish/content-remix-de.png"